import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Store } from "pullstate";
import { approveMachines, approveUsers, getMachinesAndUsers, hasNextPage, hasPrevPage, revokeMachines, revokeUsers } from "../utils/adminView";
import Toast from "../components/Toast";
var AdminViewStore = new Store({
  view: "users",
  data: null,
  viewData: {
    workspace: null,
    selectedRows: [],
    allRowsSelected: false,
    currentPage: 1,
    maxRowsPerPage: 5,
    rowsInCurrentPage: []
  }
});
function reducer(action) {
  if (action.type === "get-data") {
    var state = AdminViewStore.getRawState();
    var viewData = state.viewData;
    var workspace = viewData.workspace;
    var value = workspace.value;
    getMachinesAndUsers(value).then(function (data) {
      AdminViewStore.update(function (s) {
        s.data = {
          users: data[0].value,
          machines: data[1].value
        };
      });
    })["catch"](function (e) {
      Toast.error("Unable to get users and machines of workspace");
    });
  } else if (action.type === "set-workspace-data") {
    var _workspace = action.payload.workspace;
    AdminViewStore.update(function (s) {
      s.viewData.workspace = _objectSpread({}, _workspace);
    });
    // nested action
    reducer({
      type: "get-data"
    });
  } else if (action.type === "set-view") {
    AdminViewStore.update(function (s) {
      s.view = action.payload.view;
      s.viewData = _objectSpread(_objectSpread({}, s.viewData), {}, {
        allRowsSelected: false,
        selectedRows: [],
        currentPage: 1
      });
    });
  } else if (action.type === "record-row-selection") {
    var _action$payload = action.payload,
      id = _action$payload.id,
      level = _action$payload.level;
    var _state = AdminViewStore.getRawState();
    var activeView = _state.view;
    if (!_state.data) {
      console.warn("something awfully wrong has happened");
      return;
    }
    var activeViewData = _state.data[activeView];
    var allIds = activeViewData.map(function (x) {
      return x.id;
    });
    if (level === "column") {
      // see if the length of selected ids equals the length of all ids
      // if so, it is a signal to uncheck all of them.
      // if not, go ahead and add all ids to the list of selected ids;

      var haveEqualLengths = allIds.length === _state.viewData.selectedRows.length;
      AdminViewStore.update(function (s) {
        s.viewData.selectedRows = haveEqualLengths ? [] : allIds;
        s.viewData.allRowsSelected = !haveEqualLengths;
      });
    } else if (level === "row") {
      // if the id is already present in the list - pop it
      // if not, add it
      var isPresent = _state.viewData.selectedRows.includes(id);
      var newRows = isPresent ? _state.viewData.selectedRows.filter(function (x) {
        return x !== id;
      }) : function () {
        var a = _state.viewData.selectedRows.map(function (x) {
          return x;
        });
        a.push(id);
        return a;
      }();
      AdminViewStore.update(function (s) {
        s.viewData = _objectSpread(_objectSpread({}, s.viewData), {}, {
          selectedRows: newRows,
          allRowsSelected: newRows.length === allIds.length
        });
      });
    }
  } else if (action.type === "approve") {
    var _state2 = AdminViewStore.getRawState();
    if (_state2.view === "users") {
      var _state2$viewData$work;
      approveUsers((_state2$viewData$work = _state2.viewData.workspace) === null || _state2$viewData$work === void 0 ? void 0 : _state2$viewData$work.value, _state2.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            successfulIds.push(_state2.viewData.selectedRows[idx]);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to approve one or more users");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "APPROVED"
            }
          });
          AdminViewStore.update(function (s) {
            s.viewData.currentPage = _state2.viewData.currentPage;
          });
        }
      });
    } else if (_state2.view === "machines") {
      var _state2$viewData$work2;
      approveMachines((_state2$viewData$work2 = _state2.viewData.workspace) === null || _state2$viewData$work2 === void 0 ? void 0 : _state2$viewData$work2.value, _state2.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            successfulIds.push(_state2.viewData.selectedRows[idx]);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to approve one or more systems");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "APPROVED"
            }
          });
          AdminViewStore.update(function (s) {
            s.viewData.currentPage = _state2.viewData.currentPage;
          });
        }
      });
    }
  } else if (action.type === "revoke") {
    var _state3 = AdminViewStore.getRawState();
    if (_state3.view === "users") {
      var _state3$viewData$work;
      revokeUsers((_state3$viewData$work = _state3.viewData.workspace) === null || _state3$viewData$work === void 0 ? void 0 : _state3$viewData$work.value, _state3.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            successfulIds.push(_state3.viewData.selectedRows[idx]);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to reject one or more users");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "REJECTED"
            }
          });
          AdminViewStore.update(function (s) {
            s.viewData.currentPage = _state3.viewData.currentPage;
          });
        }
      });
    } else if (_state3.view === "machines") {
      var _state3$viewData$work2;
      revokeMachines((_state3$viewData$work2 = _state3.viewData.workspace) === null || _state3$viewData$work2 === void 0 ? void 0 : _state3$viewData$work2.value, _state3.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            successfulIds.push(_state3.viewData.selectedRows[idx]);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to reject one or more systems");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "REJECTED"
            }
          });
          AdminViewStore.update(function (s) {
            s.viewData.currentPage = _state3.viewData.currentPage;
          });
        }
      });
    }
  } else if (action.type === "approve-single-entity") {
    var _state4 = AdminViewStore.getRawState();
    if (_state4.view === "users") {
      var _state4$viewData$work;
      approveUsers((_state4$viewData$work = _state4.viewData.workspace) === null || _state4$viewData$work === void 0 ? void 0 : _state4$viewData$work.value, [action.payload.id]).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            successfulIds.push(action.payload.id);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to approve user");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "APPROVED"
            }
          });
          AdminViewStore.update(function (s) {
            s.viewData.currentPage = _state4.viewData.currentPage;
          });
        }
      });
    } else if (_state4.view === "machines") {
      var _state4$viewData$work2;
      approveMachines((_state4$viewData$work2 = _state4.viewData.workspace) === null || _state4$viewData$work2 === void 0 ? void 0 : _state4$viewData$work2.value, [action.payload.id]).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            successfulIds.push(action.payload.id);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to approve machine");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "APPROVED"
            }
          });
          AdminViewStore.update(function (s) {
            s.viewData.currentPage = _state4.viewData.currentPage;
          });
        }
      });
    }
  } else if (action.type === "revoke-single-entity") {
    var _state5 = AdminViewStore.getRawState();
    if (_state5.view === "users") {
      var _state5$viewData$work;
      revokeUsers((_state5$viewData$work = _state5.viewData.workspace) === null || _state5$viewData$work === void 0 ? void 0 : _state5$viewData$work.value, [action.payload.id]).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            successfulIds.push(action.payload.id);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to reject user");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "REJECTED"
            }
          });
          AdminViewStore.update(function (s) {
            s.viewData.currentPage = _state5.viewData.currentPage;
          });
        }
      });
    } else if (_state5.view === "machines") {
      var _state5$viewData$work2;
      revokeMachines((_state5$viewData$work2 = _state5.viewData.workspace) === null || _state5$viewData$work2 === void 0 ? void 0 : _state5$viewData$work2.value, [action.payload.id]).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            successfulIds.push(action.payload.id);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to reject machine");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "REJECTED"
            }
          });
          AdminViewStore.update(function (s) {
            s.viewData.currentPage = _state5.viewData.currentPage;
          });
        }
      });
    }
  } else if (action.type === "reset") {
    AdminViewStore.update(function (s) {
      // s.data = null;
      s.viewData = _objectSpread(_objectSpread({}, s.viewData), {}, {
        allRowsSelected: false,
        selectedRows: [],
        currentPage: 1
      });
    });
  } else if (action.type === "next-page") {
    var _state6 = AdminViewStore.getRawState();
    AdminViewStore.update(function (s) {
      if (hasNextPage(_state6)) {
        s.viewData.currentPage += 1;
      }
    });
  } else if (action.type === "prev-page") {
    var _state7 = AdminViewStore.getRawState();
    AdminViewStore.update(function (s) {
      if (hasPrevPage(_state7)) {
        s.viewData.currentPage -= 1;
      }
    });
  } else if (action.type === "first-page") {
    AdminViewStore.update(function (s) {
      s.viewData.currentPage = 1;
    });
  } else if (action.type === "last-page") {
    var _state8 = AdminViewStore.getRawState();
    if (!_state8.data) {
      return;
    }
    var lastPage = Math.ceil(_state8.data[_state8.view].length / _state8.viewData.maxRowsPerPage);
    AdminViewStore.update(function (s) {
      s.viewData.currentPage = lastPage;
    });
  } else if (action.type === "update-row") {
    var _state9 = AdminViewStore.getRawState();
    var newData = _state9.data[_state9.view].map(function (item) {
      var newItem = _objectSpread({}, item);
      if (action.payload.ids.includes(newItem.id)) {
        newItem.approved = action.payload.nextState;
        return newItem;
      }
      return newItem;
    });
    AdminViewStore.update(function (s) {
      s.data = _objectSpread(_objectSpread({}, s.data), {}, _defineProperty({}, s.view, newData));
    });
  }
}
function useAdminView() {
  var state = AdminViewStore.useState(function (s) {
    return s;
  });
  return [state, reducer];
}
export default useAdminView;